/** Single rack-name formatter. Matches backend format_rack_name (+1 display). */

export function rowIndexToLetter(index: number): string {
  let result = ''
  let n = index
  while (n >= 0) {
    result = String.fromCharCode(65 + (n % 26)) + result
    n = Math.floor(n / 26) - 1
  }
  return result
}

export function formatRackName(
  template: string | undefined,
  prefix: string | undefined,
  rowIdx: number,
  rackIdx: number,
): string {
  const pfx = prefix ?? ''
  let tmpl = template || '{prefix}/{row:02d}/{rack:02d}'
  tmpl = tmpl.replace(/\{row_letter(?::[^}]+)?\}/g, rowIndexToLetter(rowIdx))
  tmpl = tmpl.replace(/\{prefix(?::[^}]*)?\}/g, pfx)
  tmpl = tmpl.replace(/\{module(?::[^}]*)?\}/g, pfx)
  tmpl = tmpl.replace(/\{hall(?::[^}]*)?\}/g, pfx)
  tmpl = tmpl.replace(/\{row:0(\d+)d\}/g, (_, digits) =>
    String(rowIdx + 1).padStart(parseInt(digits, 10), '0'))
  tmpl = tmpl.replace(/\{rack:0(\d+)d\}/g, (_, digits) =>
    String(rackIdx + 1).padStart(parseInt(digits, 10), '0'))
  tmpl = tmpl.replace(/\{row\}/g, String(rowIdx + 1))
  tmpl = tmpl.replace(/\{rack\}/g, String(rackIdx + 1))
  return tmpl
}

/** API `label` is format_rack_name; fallback uses the same template as the calculator. */
export function rackLabel(
  r: { label?: string | null; row_index: number; rack_index: number },
  dc?: { rack_naming_template?: string; prefix?: string },
): string {
  if (r.label) return r.label
  return formatRackName(dc?.rack_naming_template, dc?.prefix, r.row_index, r.rack_index)
}
